var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort-wrapper",attrs:{"ar":_vm.$i18n.locale === 'ar'},on:{"click":function($event){_vm.$emit('input', _vm.value == 1 ? 2 : 1); _vm.$emit('change');}}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.value == 1 ? _vm.asc : _vm.desc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }